import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { CleanTransportComponent } from './clean-transport/component/clean-transport.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';



@NgModule({
  declarations: [
    CleanTransportComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    CommonLayoutModule,
    CommonUIModule,
    CommonTranslationModule,
    ServiceResponseModule
  ]
})
export class CleanTransportModule { }
